import React from 'react';
import {
  Box,
  Container,
} from '@mui/material';
import { ZAvatar } from '@marageti/z4-lib';
import { ViewProps } from './types';
import ProfileCard from './profile-info';
import ProfileEditor from '../../../components/settings-profile/edit-user-form';
import styles from './styles';

const View = ({
  contextMenuAnchor,
  contextMenuOpen,
  editorOpen,
  onCloseContextMenu,
  onCloseEditor,
  onEditAvatar,
  onOpenContextMenu,
  onOpenEditor,
  teamMember,
}: ViewProps) => (
  <Container maxWidth="md">
    <Box sx={styles.profileWrapper}>
      <Box sx={styles.avatarBoxMobile}>
        <ZAvatar
          name={teamMember?.fullName}
          size={128}
          loading={!teamMember}
          onEdit={onEditAvatar}
          src={teamMember?.avatar}
        />
      </Box>
      <ProfileCard
        contextMenuAnchor={contextMenuAnchor}
        contextMenuOpen={contextMenuOpen}
        onCloseContextMenu={onCloseContextMenu}
        onEditAvatar={onEditAvatar}
        onOpenContextMenu={onOpenContextMenu}
        onOpenEditor={onOpenEditor}
        teamMember={teamMember}
      />
      <ProfileEditor open={editorOpen} onClose={onCloseEditor} />
    </Box>
  </Container>
);

export default View;
